import { createContext } from "react";
import {
  IMerchant,
  ILoginPayload,
  ISignUpPayload,
  IAccountOption,
  IIntegrationOption,
  ISubscriptionDetails,
  IUserPreferences,
  IViewAsPayload,
} from "../interfaces";
import { RouteConfig } from "../config/routes";

export interface AuthContextType {
  user: IMerchant | null;
  /** True when the user themselves is VIP, or is a custom_admin whose parent is VIP. */
  isVip: boolean;
  subscriptionDetails: ISubscriptionDetails | null;
  permittedRoutes: RouteConfig[];
  isAuthenticated: boolean;
  isLoading: boolean;
  selectedAccount: IAccountOption;
  selectedIntegration: IIntegrationOption | null;
  teams: IMerchant[];
  loggingOut: boolean;
  sessionId: string;
  wsConnected: boolean;
  lastPing: {
    status?: string;
    uptime?: number;
    downtime?: number;
    last_ping_time?: string;
  } | null;
  sendLogout: (logoutPayload: {
    type: string;
    user_id: string;
    session_id: string;
    time: string;
  }) => boolean;
  aiSessionToken: string | null;
  getAiSessionToken: () => Promise<string | null>;
  login: (credentials: ILoginPayload) => Promise<void>;
  takeOverLogin: (credentials: IViewAsPayload) => Promise<void>;
  logout: () => void;
  signup: (userData: ISignUpPayload) => Promise<void>;
  setUser: (user: IMerchant | null) => void;
  setSelectedAccount: (account: IAccountOption) => void;
  setSelectedIntegration: (integration: IIntegrationOption) => void;
  updatePreferences: (preferences: IUserPreferences) => Promise<IMerchant>;
  refreshUser: () => Promise<void>;
  connectedAdsPlatforms: string[];
  setConnectedAdsPlatforms: (platforms: string[]) => void;
  schemaSetup: {
    progress: number;
    status: "pending" | "in_progress" | "completed" | "failed";
    message: string;
    isConnected: boolean;
    usedFallback: boolean;
  };
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
